module.exports = __webpack_public_path__ + "img/fopeaInsultosX.4bb0e0f4.jpg";